export default () => ({
  colGap: '3rem',
  rowGap: '1.25rem',
})
